"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailRegistrationFormContainer = void 0;
var _reactRedux = require("react-redux");
var _authentication = require("../../../../actions/authentication");
var _login = require("../../../../actions/login");
var _registration = require("../../../../actions/registration");
var _selectors = require("./selectors");
var _autoFocusDisabled = require("../../../../selectors/autoFocusDisabled");
var _EmailRegistrationFormContainer = require("./EmailRegistrationFormContainer");
var _source = require("../../../../selectors/source");
function mapStateToProps(state) {
  return {
    isSubmitting: (0, _selectors.isFormSubmitting)(state),
    login: (0, _selectors.loginSelector)(state),
    loginError: (0, _selectors.loginErrorSelector)(state),
    isLoginInvalid: (0, _selectors.isLoginInvalidSelector)(state),
    hasAsyncLoginError: (0, _selectors.hasLoginErrorSelector)(state),
    password: (0, _selectors.passwordSelector)(state),
    passwordError: (0, _selectors.passwordErrorSelector)(state),
    isPasswordInvalid: (0, _selectors.isPasswordInvalidSelector)(state),
    hasAsyncPasswordError: (0, _selectors.hasPasswordErrorSelector)(state),
    autoFocusDisabled: (0, _autoFocusDisabled.selectAutoFocusDisabled)(state),
    isProfessionalUser: (0, _selectors.isProfessionalUserSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    changeLogin(login) {
      dispatch((0, _login.changeLogin)(login));
    },
    changePassword(password) {
      dispatch((0, _authentication.changePassword)(password));
    },
    register(params) {
      dispatch((0, _registration.register)(params));
    }
  };
}
const EmailRegistrationFormContainer = exports.EmailRegistrationFormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_EmailRegistrationFormContainer.EmailRegistrationFormContainer);